import Amplify from "@aws-amplify/core";
import awsExports from "../aws-exports";

Amplify.configure(awsExports);

export default Amplify;
